import { useState } from "react";
import SideBar from "../SideBar/Index";
import FWF from "./FWF/Index";
import CSV from "./CSV/Index";
import OFX from "./OFX/Index";
import Main from "./Main/Index";

export default function Index(props) {
  let [containerType, setContainerType] = useState(0);
  let [layoutId, setLayoutId] = useState(0);
  let [layout, setLayout] = useState(null);

  let handleClickMenuItem = (containerType, layoutId = 0, layout) => {
    setContainerType(containerType);
    setLayoutId(layoutId);
    setLayout(layout);
  };

  return (
    <>
      <SideBar
        handleClickMenuItem={handleClickMenuItem}
        groupedLayouts={props.groupedLayouts}
      />

      {containerType == 0 && <Main />}
      {containerType == 1 && (
        <FWF layout={layout} layoutId={layoutId} key={layoutId} />
      )}
      {containerType == 2 && <CSV layoutId={layoutId} />}
      {containerType == 3 && <OFX layoutId={layoutId} />}
    </>
  );
}
